import { Injector, ModuleWithProviders, NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { DbService } from './db.service';
import { DB_TYPE_ACTION_MAPPING } from './db.tokens';
import { DbEffects } from './state-management/effects/db';


@NgModule({
	imports: [
		EffectsModule.forFeature([DbEffects])
	]
})
export class DbModule {
	constructor(private dbService: DbService, injector: Injector) {
		dbService.registerActions(injector.get(DB_TYPE_ACTION_MAPPING));
	}

	static forRoot(): ModuleWithProviders {
		return {
			ngModule: DbModule,
			providers: [DbService],
		};
	}

	static forChild(): ModuleWithProviders {
		return {
			ngModule: DbModule,
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/db/db.module.ts